import React from "react";
import { Box, Grid, Card, CardContent, CardActions, Skeleton } from "@mui/material";

export const LoadingSkeleton: React.FC = () => (
  <Grid container spacing={3}>
    {[1, 2, 3, 4, 5, 6].map((i) => (
      <Grid item xs={12} sm={6} md={4} key={i}>
        <Card elevation={2}>
          <CardContent>
            <Skeleton variant="text" width="60%" height={32} />
            <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="text" width="80%" height={20} sx={{ mb: 2 }} />
            <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
              {[1, 2, 3].map((j) => (
                <Skeleton key={j} variant="circular" width={28} height={28} />
              ))}
            </Box>
            <Skeleton variant="text" width="100%" height={24} />
            <Skeleton variant="text" width="100%" height={24} />
          </CardContent>
          <CardActions sx={{ px: 2, pb: 2 }}>
            <Skeleton variant="rounded" width="100%" height={36} />
          </CardActions>
        </Card>
      </Grid>
    ))}
  </Grid>
);

